// src/pages/PrivacyPage.tsx
import React from "react";
import { appData } from "../data/appData"; // Ensure this import is correct
import PageConfigurator from "../components/PageConfigurator";
import "../styles/PrivacyPage.css"; // Ensure this file exists

const PrivacyPage: React.FC = () => {
  return (
    <PageConfigurator pageData={appData.pages.privacy} pageName="privacy" />
  );
};

export default PrivacyPage;
